
const MILLI_MULTIPLYER = 1000
const TOKEN_GRACE_PERIOD = 2000

// returns timestamp
const getTokenExpiry = (token: string): number => {
  const tokenParts = token.split('.')
  const decodedTokenData = Buffer.from(tokenParts[1] || '', 'base64').toString()
  const parsedTokenData = JSON.parse(decodedTokenData)

  // because api returns seconds, but Date.now() works in millis
  return parsedTokenData.exp * MILLI_MULTIPLYER || 0
}

export const isExpiredToken = (token: string) => 
  // we'll assume a generous time of 2 seconds for api to
  // process our request
  getTokenExpiry(token) - TOKEN_GRACE_PERIOD <= Date.now()
